import React, { Component } from 'react';
import { Layout } from '$components/project';
import { connect } from 'react-redux';
import { fetchAll, clear } from '$actions/projects';
import { createReport } from '$actions/submissions';
import { showNotification, changeTitle } from '$actions/root';
import { projectsSelector } from '$selectors';
import { deleteProject, getProject, getInsight, getActivityMap, getProjects } from '../../api';
import { take, has, isEqual } from 'lodash';
import { Translate } from '$common';
import { browserHistory } from 'react-router';
import { ProjectLoader } from '$common/loaders';


const statusMap = {
  active: {
    value: { status_eq: 1 }
  },
  draft: {
    value: { status_eq: 0 }
  },
  inactive: {
    value: { status_eq: 2 }
  },
  finished: {
    value: { status_eq: 3 }
  }
}

@connect((state) => ({
  projects: projectsSelector(state),
  hasMore: state.projects.hasMore,
  isFetching: state.projects.isFetching
}), { fetchAll, clear, showNotification, createReport, changeTitle })
export default class LayoutRoute extends Component {
  
  state = {
    page: 1,
    filters: [],
    submissions: [],
    filteredProjects: null
  };

  async loadData(projectId = null) {
    const { params } = this.props;
    if (projectId || params.id) {
      const { data: project } = await getProject(projectId || params.id);
      const { data: insight } = await getInsight(projectId || params.id);

      this.setState({ project: { ...project, insight } });
    }
  }

  async loadActivityMap() {
    const { params } = this.props;
    const { data: activity_map } = await getActivityMap(params.id);
    this.setState({ activity_map });
  }

  async deleteProject(id) {
    try {
      await deleteProject(id);
      this.props.showNotification('Project has been deleted','success');
      this.props.clear();
      browserHistory.push('/project');
    } catch(e) {
      console.log(e);
    }
  }

  componentWillMount() {
    this.props.clear();
    this.fetch();

    this.props.changeTitle(Translate.get('projects'))
  }

  loadAllData(projectId = null) {
    this.fetch();
    this.loadData(projectId);
    this.loadActivityMap();
  }

  getQueryFilters() {
    let query = {};
    let filters = [...this.state.filters];
    if (this.props.params.type) filters.push(statusMap[this.props.params.type]);
    filters.forEach(i => query = { ...query, ...i.value });
    return query;
  }

  fetch() {
    const params = { page: this.state.page };
    if (this.state.filters) params.q = this.getQueryFilters();
    this.props.fetchAll(params);
    this.stopLoadMore = false;
  }

  createReport({ type }) {
    this.props.createReport(this.props.params.id, type, this.props.location.query);
  }

  componentWillReceiveProps(props) {
    const query = this.props.params;
    const nextQuery = props.params;

    if (!isEqual(query, nextQuery)) {
      this.setState({ project: undefined, insight: undefined });

      this.fetch();
      this.loadData(nextQuery.id);

      if (this.state.project) {
        this.loadActivityMap();
      }
    }
  }

  async getProjects(key, value) {
    if (value.length > 0) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        getProjects(value).then(({ data: filteredProjects }) => {
          this.setState({ filteredProjects });
        });
      }, 500);
    } else {
      this.setState({ filteredProjects: null })
    }
  }

  render() {
    let { projects, isFetching, location } = this.props;
    const { filteredProjects, page, project, activity_map } = this.state;

    return !isFetching ? (
      <Layout
        projects={filteredProjects || projects}
        getProjects={::this.getProjects}
        project={project}
        onDeleteProject={::this.deleteProject}
        params={this.props.params}
        insight={project && project.insight || {}}
        activityMap={activity_map}
        currentPage={page || 1}
        onLoadAllData={::this.loadAllData}
        query={location.query}
      >
        {this.props.children}
      </Layout>
    ) : null
  }
}



// WEBPACK FOOTER //
// ./src/routes/project/layout.js